<template>
  <div class="container">
    <slot name="before"></slot>
    <div
      class="editable"
      :class="{
        'editable-border': borderVisible,
      }"
      :style="{
        width: inputWidth + 'px',
      }"
    >
      <label
        v-if="label"
        :for="id"
        class="base-text"
        :style="{ 'font-size': fontSize, color: fontColor }"
        >{{ label }}</label
      >
      <input
        ref="inputRef"
        type="text"
        :id="id"
        class="base-text base-input"
        :value="props.modelValue"
        @input="onInput"
        v-bind="$attrs"
        :style="{
          'font-size': fontSize,
          color: fontColor,
        }"
        :placeholder="placeholder"
        @paste="filterPaste"
        @keydown="filter"
      />
      <label :for="id" class="edit-icon">
        <img src="@/assets/icons/edit.svg" alt="Ikona edycji"
      /></label>
      <span
        ref="dummySpanRef"
        :style="{
          'font-size': fontSize,
          color: fontColor,
        }"
        class="base-text get-width"
      >
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
const props = defineProps({
  modelValue: [String, Number],
  label: String,
  placeholder: String,
  id: String,
  fontSize: String,
  fontColor: String,
  /** Makes the bottom border always visible */
  borderVisible: Boolean,
  postfix: String,
  number: Boolean,
  decimal: Boolean,

  /** hasIcon is made to display one icon only - it is like, so we can adjust width of the input */
  hasIcon: Boolean,
});
const emit = defineEmits(["update:modelValue"]);

const inputRef = ref(null);

/**
 * Span ref used to add text to it and get the width of the input.
 * It is used, because to change the width of the input we need real measures.
 * In a font, that is not monospace we cannot measure the width based on characters count correctly.
 */
const dummySpanRef = ref(null);

/** Value in px */
const inputWidth = ref(160);
/**
 * Text to measure the size span's width with given text
 * @param {string} text
 */
function calculateInputWidth(incomingText) {
  let text = incomingText || props.placeholder;

  const empty = "-".repeat(4);
  // add empty characters to label, because of padding
  const label = props.label ? props.label + "-" : "";
  // get label + text + empty characters to have min width
  dummySpanRef.value.innerText = label + text + empty;
  const width = dummySpanRef.value.offsetWidth;

  inputWidth.value = width;
}
onMounted(() => {
  calculateInputWidth(props.modelValue);
});

watch(
  () => props.modelValue,
  (v) => {
    calculateInputWidth(v);
  }
);

function onInput(event) {
  const text = event.target.value;
  emit("update:modelValue", text);
}

function filter(event) {
  const allowKeyCode = [8, 9, 37, 39];
  if (allowKeyCode.includes(event.keyCode)) return;

  let isValid = true;

  if (props.number) {
    const regexp = /^[0-9]+(\.[0-9]+)?$/;
    isValid = regexp.test(event.key);
  }

  if (props.decimal) {
    const regex = /^[0-9]*(\.[0-9]{0,2})?$/;
    const mergeValue = inputRef.value.innerText + event.key;
    isValid = regex.test(mergeValue);
  }

  if (!isValid) {
    event.preventDefault();
  }
}

function filterPaste(e) {
  const pastedData = e.clipboardData.getData("text");
  const regex = /^[a-zA-Z0-9@  `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+$/;

  if (regex.test(pastedData) !== true) {
    e.preventDefault();
  }
}
</script>
<style scoped lang="scss">
.container {
  display: flex;
  align-items: center;
}
.base-text {
  font-weight: 500;
  font-size: 1.625rem;
  color: #8c8f94;
  font-family: "Montserrat";
}
.editable {
  display: flex;
  align-items: baseline;
  cursor: text;
  max-width: 400px;
  @media (max-width: 1050px) {
    max-width: 350px;
  }
  @media (max-width: 950px) {
    max-width: 300px;
  }
  @media (max-width: 450px) {
    max-width: 250px;
  }

  &-border {
    border-bottom: 1px solid #cacaca;
  }
  label {
    padding-bottom: 0.3rem;
    padding-right: 0.25em;
    cursor: text;
  }

  .base-input {
    padding-bottom: 0.3rem;
    background-color: transparent;
    border: none;
    cursor: text;
    width: 100%;
  }
  border-bottom: 1px solid transparent;
  &:focus-within {
    border-bottom: 1px solid #cacaca;
    .base-input {
      outline: none;
      /* min-width: 160px; */
    }
  }
}
.edit-icon {
  /* content: url("@/assets/icons/edit.svg"); */
  width: 12px;
  height: 12px;
  margin-left: 0.25em;
  cursor: pointer;
}
.get-width {
  position: fixed;
  top: -100vh;
  left: -100vw;
  z-index: 10;
}
</style>
